import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import moment from "moment";

import EditNutritionJournal from "./add/editJournalPanel";
import { deleteNutritionJournal, resetField } from "../../../store/actions";
import PaginatedTable from "../../../sharedComponents/tableWithPagination";
import ConfirmDelete from "../../../sharedComponents/confirmDelete";

const JournalEntries = ({
	getNutrionJournalEntries,
	deleteNutritionJournal,
	journal,
	courseOptions,
	togglePanel,
	onUpdate,
	date,
	ingredientWeights
}) => {
	const queryString = `start_date=${moment(date ? date : new Date()).format("YYYY-MM-DD")}&end_date=${moment(
		date ? date : new Date()
	).format("YYYY-MM-DD")}`;

	const [toggleEditJournal, setToggleEditJournal] = useState(false);
	const [editValues, setEditValues] = useState("");
	const [deleteItem, setDeleteItem] = useState("");
	const [showModal, setShowModal] = useState(false);

	useEffect(() => {
		getNutrionJournalEntries(queryString);
	}, [getNutrionJournalEntries, queryString]);

	const handleEditJournal = (data) => {
		setToggleEditJournal(true);
		setEditValues(data);
	};

	const handleDeleteJournal = (original) => {
		setDeleteItem(original);
	};

	const confirmEvent = (yes) => {
		const successHandler = (res) => {
			onUpdate && onUpdate();
			getNutrionJournalEntries(queryString);
		};
		if (yes && deleteItem) {
			deleteNutritionJournal(deleteItem, successHandler);
			setDeleteItem(null);
			setShowModal(false);
		} else {
			setDeleteItem(null);
		}
	};

	const mealMapping = (original) => {
		if (original.meal) {
			const meal = courseOptions.filter((item) => item.id === original.meal);
			return meal && meal.length > 0 ? meal[0].name : "-";
		}
		return "-";
	};

	const columns = [
		{
			Header: "MEALS / SNACKS",
			accessor: "recipe_name",
			sortable: false,
			Cell: ({ original }) => (
				<span>
					{original.recipe_name
						? original.recipe_name
						: original.food_name
						? original.food_name
						: original.food_long_desc
						? original.food_long_desc
						: " - "}
				</span>
			)
		},
		{
			Header: "TIME",
			accessor: "time",
			sortable: false,
			width: 100,
			Cell: ({ original }) => <span> {original.time ? original.time : "-"} </span>
		},
		{
			Header: "COURSE",
			accessor: "meal",
			width: 100,
			Cell: ({ original }) => <span> {mealMapping(original)} </span>
		},
		{
			Header: "QTY",
			accessor: "quantity",
			sortable: false,
			width: 70,
			Cell: ({ original }) => <span> {original.quantity ? original.quantity : "-"} </span>
		},
		{
			Header: "PROTEIN CALS",
			accessor: "protein_calories",
			width: 120,
			sortable: false,
			Cell: ({ original }) => <span>{original.protein_calories ? original.protein_calories : "-"} </span>
		},
		{
			Header: "SERVINGS OF",
			columns: [
				{
					Header: "VEG",
					accessor: "vegetable",
					sortable: false,
					width: 70,
					Cell: ({ original }) => <span> {original.vegetable ? original.vegetable : "-"} </span>
				},
				{
					Header: "FAT",
					accessor: "ssvg_fat",
					sortable: false,
					width: 70,
					Cell: ({ original }) => <span> {original.ssvg_fat ? original.ssvg_fat : "-"} </span>
				},
				{
					Header: "STARCH",
					accessor: "starch",
					sortable: false,
					width: 90,
					Cell: ({ original }) => <span> {original.starch ? original.starch : "-"} </span>
				},
				{
					Header: "FRUITS",
					accessor: "fruit",
					sortable: false,
					width: 80,
					Cell: ({ original }) => <span> {original.fruit ? original.fruit : "-"} </span>
				},
				{
					Header: "DAIRY",
					accessor: "dairy",
					sortable: false,
					width: 70,
					Cell: ({ original }) => <span> {original.dairy ? original.dairy : "-"} </span>
				},
				{
					Header: "MISC",
					accessor: "misc",
					sortable: false,
					width: 70,
					Cell: ({ original }) => <span> {original.misc ? original.misc : "-"} </span>
				}
			]
		},
		{
			Header: "HUNGER",
			className: "print-hidden",
			columns: [
				{
					Header: "BEFORE",
					accessor: "hunger_before",
					sortable: false,
					width: 80,
					headerClassName: "text-center",
					className: "text-center print-hidden",
					Cell: ({ original }) => <span> {original.hunger_before ? original.hunger_before : "-"} </span>
				},
				{
					Header: "AFTER",
					accessor: "hunger_after",
					sortable: false,
					width: 70,
					headerClassName: "text-center",
					className: "text-center print-hidden",
					Cell: ({ original }) => <span> {original.hunger_after ? original.hunger_after : "-"} </span>
				}
			]
		},
		{
			Header: "Actions",
			accessor: "id",
			sortable: false,
			className: "text-right print-hidden ",
			headerClassName: "text-right",
			width: 90,
			Cell: ({ original }) => (
				<div>
					<button
						className="btn btn-success btn-ghost btn-cell btn-sm mr-2"
						onClick={() => handleEditJournal(original)}>
						<i className="icon icon-edit" />
					</button>
					<button className="btn btn-danger btn-ghost btn-cell btn-sm" onClick={() => handleDeleteJournal(original)}>
						<i className="icon icon-trash" />
					</button>
				</div>
			)
		}
	];

	return (
		<div className="card card-primary border-0 p-4">
			<div className="d-flex flex-row justify-content-between">
				<h4 className="text-primary-dark"> Journal Entries </h4>
			</div>
			<PaginatedTable
				data={journal ? journal : []}
				columns={columns}
				className="table-default"
				pageSize={journal.length}
			/>

			{toggleEditJournal && (
				<EditNutritionJournal
					initialValues={editValues}
					toggleEditJournal={toggleEditJournal}
					setToggleEditJournal={setToggleEditJournal}
					onUpdate={onUpdate}
				/>
			)}
			<ConfirmDelete
				item={deleteItem ? deleteItem : showModal}
				message="Are you sure want to delete?"
				onEvent={confirmEvent}
			/>
		</div>
	);
};

const mapDispatchToProps = { deleteNutritionJournal, resetField };

export default connect(
	null,
	mapDispatchToProps
)(JournalEntries);
